import request from '@/utils/request'

export function modifyuserinfo(query) {
	return request({
		url: 'api/modifyuserinfo',
		method: 'post',
		data: query
	})
}

export function modifyavatar(query) {
	return request({
		url: 'api/modifyavatar',
		method: 'post',
		data: query
	})
}
 

